import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { StorageService } from '../core/services/storage.service';
import { CommonService } from '../core/services/common.service';
import { CategoryService } from '../core/services/category.service';
import { Location } from '@angular/common';
import { GlobalConstants } from '../shared/constants/global-constants';

@Component({
  selector: 'app-control-assessment',
  templateUrl: './control-assessment.component.html',
  styleUrls: ['./control-assessment.component.css']
})
export class ControlAssessmentComponent implements OnInit {

  selectedCategoryDetails: any;
  selectedCategory = '';
  assessmentDetails: any;
  noQuesError!: string;
  quesList: any;
  categoryList = [];
  categoryArabicList = [];
  statusOfStageCompletion: any;
  questionnaire: any;
  questionnaireType: string = '';
  isArabic!: boolean;
  isChecker: any;
  noOfTypeQues: any;
  isView: any;
  totalEachTypeQuestions: any;
  subscriptionEvent: any;
  isSelectedSectionLast: boolean = false;
  isSelectedCategoryLast: boolean = false;
  reVisitUnAnswered: boolean = false;
  returnToAssessment: boolean = false;
  allQstnAns: any;
  unansweredQues: any;
  isResubmit: boolean = false;
  isRouteToSameSection!: boolean;
  selectedQuestionState: any;
  returnQuestion!: any;
  isMakerCheckerEnabled: any;
  userDetails: any;
  progressCountState: any;
  showGeneralSection: boolean = true;
  showInherentSection: boolean = true;
  showControlSection: boolean = true;

  constructor(private route: Router, private activateRoute: ActivatedRoute, private categoryService: CategoryService,
    private assessmentService: AssessmentService, private storageService: StorageService, private commonService: CommonService,
    private location: Location
  ) {
    route.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit(): void {
    // const selectedQuestionState = this.storageService.getSessionStorageData('selectedQuestionState');
    // if (selectedQuestionState) {
    //   this.returnQuestion = selectedQuestionState;

    // }
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.assessmentDetails = this.storageService.getSessionStorageData('assessmentDetails');
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');


    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      this.reVisitUnAnswered = false;
      this.returnToAssessment = false;
      this.isResubmit = false;
      if (queryParam.hasOwnProperty('questionnairetype')) {
        if (this.questionnaireType == queryParam.questionnairetype) {
          this.isRouteToSameSection = true;
        }
        else {
          this.isRouteToSameSection = false;
        }
        this.questionnaireType = queryParam.questionnairetype;
        this.questionnaire = this.assessmentDetails.questionnaireguid;
        let rqstBody: any;
        if (queryParam.hasOwnProperty('action') && queryParam.action == 'resubmit') {
          this.isResubmit = true;
          const REJECTED_STATUS_VALUE = this.isChecker ?
            GlobalConstants.STATUSES.REJECTED.value :
            (this.isMakerCheckerEnabled ?
              GlobalConstants.STATUSES.CHECKER_REJECTED.value :
              GlobalConstants.STATUSES.REJECTED.value);
          const DRAFT_STATUS_VALUE = GlobalConstants.STATUSES.DRAFT.value;
          //rqstBody = { questionnaire: this.questionnaire, assessmentType: this.questionnaireType, ques: this.assessmentDetails.quesguid, actionType: 'resubmit' };
          rqstBody = {
            questionnaire: this.questionnaire,
            assessmentType: this.questionnaireType,
            actionType: 'resubmit',
            rejectStatus: REJECTED_STATUS_VALUE,
            draftStatus: DRAFT_STATUS_VALUE,
            assessmentUnit: this.userDetails.assessmentUnitValue
          };
        } else {
          rqstBody = { questionnaire: this.questionnaire, assessmentType: this.questionnaireType, actionType: 'save' };
          if (queryParam.hasOwnProperty('action') && queryParam.action == 'view') {
            this.isView = true;
          }
        }
        if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'unanswered') {
          this.reVisitUnAnswered = true;
        }
        else if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'return') {
          this.returnToAssessment = true;
        }

        if (!this.isRouteToSameSection ||
          (this.isRouteToSameSection && this.reVisitUnAnswered) ||
          (this.isRouteToSameSection && this.returnToAssessment)
        ) {
          this.assessmentService.fetchCategories(rqstBody).subscribe((res) => {
            let decryptedData = this.commonService.decryptUsingAES256(res?.data);
            let resp = JSON.parse(JSON.stringify(decryptedData));
            //console.log('finally categories list in control assessment: ', resp);
            this.statusOfStageCompletion = resp.stages;
            this.categoryList = this.statusOfStageCompletion.map((ele: any) => ele?.category);
            this.categoryArabicList = this.statusOfStageCompletion.map((ele: any) => ele?.categoryArabic);
            let noOfquestionnaireTypeQues = resp.totalEachTypeQuestions;
            this.noOfTypeQues = noOfquestionnaireTypeQues.filter((ele: any) => ele.name === this.questionnaireType);
            this.checkLastStageStatus(noOfquestionnaireTypeQues);
            this.generateCountOfQues();
            if (this.reVisitUnAnswered) {
              this.fetchAllQuesAns(true, false);
            }
            else {
              this.initialSelectedStage();
            }
          });
        }
      }
    });

    // adding here instead of tabs component
    //assessmentProgressChange
    // this.categoryService.reduceQuesCountValue$.subscribe((value) => {
    //   if (value && value > 0) {
    //     this.generateCountOfQues();
    //   }
    // })
    //assessmentProgressChange
    this.categoryService.isAssessmentProgressChange$.subscribe((value) => {
      if (value) {
        this.generateCountOfQues();
      }
    })

    //reevaluate hide tab logic based on rejected ques
    if (this.isResubmit) {
      // console.log("isResubmit........")
      this.fetchAllQuesAns(false, true);
    }
  }

  checkLastStageStatus(totalEachTypeQuestions: any) {
    this.isSelectedSectionLast = false;
    if (totalEachTypeQuestions?.length > 0 && this.noOfTypeQues?.length > 0) {
      const remainingSection = totalEachTypeQuestions.filter((x: any) => x.value > this.noOfTypeQues[0].value);
      if (remainingSection.length > 0) {
        if (remainingSection.filter((y: any) => y.totalcount > 0).length == 0) {
          this.isSelectedSectionLast = true;
        }
      }
      else {
        this.isSelectedSectionLast = true;
      }
    }
  }

 
  fetchAllQuesAns(isNavigateToUnanswered: boolean = false, isResubmit: boolean = false) {
    let allQuestions: any;
    let allAnswers: any;

    const rqstBodyAllQstn = {
      questionnaire: this.assessmentDetails.questionnaireguid,
    };

    this.assessmentService.fetchAllQuestions(rqstBodyAllQstn).subscribe((data) => {
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
      // console.log('Decrypted questions:', decryptedData);
      allQuestions = decryptedData?.questionsList;

      if (isNavigateToUnanswered) {
        allQuestions = allQuestions.filter((question: any) => question?.section == this.questionnaireType);
      }

      const rqstBodyAns = {
        questionnaire: this.assessmentDetails.questionnaireguid,
        assessmentUnit: this.assessmentDetails?.assessmentunitguid,
      };

      this.assessmentService.fetchExecutorResponses(rqstBodyAns).subscribe((res) => {
        let decryptedDataAns = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedDataAns));
        allAnswers = resp.executorResponses;

        // console.log('Sample executor responses:', allAnswers.slice(0, 5)); // Debug sample

        // Map status and statusValue for each question
        allQuestions.forEach((question: any) => {
          const answer = allAnswers.find((eachAnswer: any) => eachAnswer.ques === question.quesguid);
          question.responseId = answer?.responseId;
          question.userResponse = answer?.quesResponse;
          question.status = answer?.statusOfResponse;

          if (answer && answer.statusOfResponse) {
            const foundStatus = Object.values(GlobalConstants.STATUSES).find(
              (s: any) => s.name.toLowerCase().trim() === answer.statusOfResponse.toLowerCase().trim()
            );
            question.statusValue = foundStatus ? foundStatus.value : null;
            if (!foundStatus) {
              // console.warn(`Status name '${answer.statusOfResponse}' not mapped to numeric value.`);
            }
          } else if (answer?.quesType) {
            question.statusValue = answer.quesType;
          } else {
            question.statusValue = null;
          }
        });

        this.allQstnAns = allQuestions;

        // Log constants to validate
        // console.log('Rejected status values:', [
        //   GlobalConstants.STATUSES.CHECKER_REJECTED.value,
        //   GlobalConstants.STATUSES.INSPECTOR_REJECTED.value,
        // ]);

        // Log all questions statusValue before filtering
        // console.log('Questions statusValues before filtering:', this.allQstnAns.map((q: any) => ({
        //   quesguid: q.quesguid,
        //   statusValue: q.statusValue,
        // })));

        if (isResubmit) {
          const rejectedStatusValues = [
            GlobalConstants.STATUSES.CHECKER_REJECTED.value,
            GlobalConstants.STATUSES.INSPECTOR_REJECTED.value,
          ];
          // console.log(rejectedStatusValues)
          const filteredByValue = this.allQstnAns.filter((q: any) =>
            rejectedStatusValues.includes(q.statusValue)
          );

          // console.log('Filtered by rejected statusValue count:', filteredByValue.length);

          if (filteredByValue.length === 0) {
            // console.warn('No rejected questions found. Showing all questions instead.');
            this.allQstnAns = this.allQstnAns; // fallback: show all questions
          } else {
            this.allQstnAns = filteredByValue;
          }

          // console.log('After filtering rejected questions length:', this.allQstnAns.length);
        }

        if (isNavigateToUnanswered || isResubmit) {
          this.initialSelectedStage();
        }

        if (isResubmit) {
          this.revaluateTabHiding();
        }
      });
    });
  }
  revaluateTabHiding() {
    // const REJECTED_STATUS = this.isChecker ?
    //   GlobalConstants.STATUSES.REJECTED.name :
    //   (this.isMakerCheckerEnabled ?
    //     GlobalConstants.STATUSES.CHECKER_REJECTED.name :
    //     GlobalConstants.STATUSES.REJECTED.name);

    // let rejectedOrDraftQuesAns = this.allQstnAns.filter((quesanswer: any) => {
    //   const isRejectedOrDraft = (quesanswer?.status == REJECTED_STATUS ||
    //     quesanswer?.status == GlobalConstants.STATUSES.DRAFT.name) ? true : false;
    //   console.log("each ques status:", quesanswer?.statusOfResponse)
    //   return isRejectedOrDraft;
    // })
    // Define rejected status values to filter by numerics

    // console.log('revaluateTabHiding called, allQstnAns length:', this.allQstnAns);

    if (!this.allQstnAns || !this.allQstnAns.length) {
      // console.warn('No questions loaded for filtering.');
      return;
    }

    // Define rejected status values depending on whether user is checker or not
    let rejectedStatusValues = [GlobalConstants.STATUSES.REJECTED.value];

    if (!this.isChecker) {
      rejectedStatusValues = rejectedStatusValues.concat([
        GlobalConstants.STATUSES.CHECKER_REJECTED.value,
        GlobalConstants.STATUSES.INSPECTOR_REJECTED.value
      ]);
    }

    let rejectedOrDraftQuesAns = this.allQstnAns.filter((quesanswer: any) => {
      const isRejectedOrDraft =
        rejectedStatusValues.includes(quesanswer?.statusValue) ||
        quesanswer?.status === GlobalConstants.STATUSES.DRAFT.name;
      // console.log(`QuestionID: ${quesanswer?.quesguid}, statusValue: ${quesanswer?.statusValue}, isRejectedOrDraft: ${isRejectedOrDraft}`);
      return isRejectedOrDraft;
    });
    // console.log("resubmit ques",rejectedOrDraftQuesAns)
    let generalQues = rejectedOrDraftQuesAns.filter((t: any) => t.section == "General")
    let inherentQues = rejectedOrDraftQuesAns.filter((t: any) => t.section == "Inherent Risk")
    let controlQues = rejectedOrDraftQuesAns.filter((t: any) => t.section == "Controls")

    // let genQues = rejectedOrDraftQuesAns.filter((q: any) => q.section == "Gnenral");
    // let genQues2 = rejectedOrDraftQuesAns.filter((item: any) => item.section == "Inherent Risk");
    // let genQues3 = rejectedOrDraftQuesAns.filter((item: any) => item.section == "Control");

    if (generalQues.length == 0) {
      this.showGeneralSection = false;
    }
    if (inherentQues.length == 0) {
      this.showInherentSection = false;
    }
    if (controlQues.length == 0) {
      this.showControlSection = false;
    }
    // console.log("generalQues",generalQues)
    // console.log("inherentQues",inherentQues)
    // console.log("controlQues",controlQues)


  }

  categoryFromMenu(categoryName: any) {
    //console.log('ttt', categoryName);
    this.selectedCategory = categoryName;
    this.selectedCategoryDetails = this.statusOfStageCompletion?.find((eachStage: any) => eachStage.category === categoryName);
    this.checkLastCategoryStatus();
    if (this.isView) {
      this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: this.questionnaireType, action: 'view' } });
    }
    else if (this.isResubmit) {
      this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: this.questionnaireType, action: 'resubmit' } });
    }
    else {
      this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: this.questionnaireType } });
    }
  }

  tabChangeFromMenu(evnt: any) {
    // setTimeout(() => {
    if (evnt) {
      let questionnaireType;
      if (this.questionnaireType == 'General') {
        if (
          (!this.isResubmit && this.totalEachTypeQuestions.filter((sec: any) => sec?.name == "Inherent Risk")[0]?.totalcount > 0) ||
          (this.isResubmit && this.showInherentSection &&
            (this.totalEachTypeQuestions.filter((sec: any) => sec?.name == "Inherent Risk")[0]?.rejected > 0))
        ) {
          questionnaireType = 'Inherent Risk';
        }
        else if (
          (!this.isResubmit && this.totalEachTypeQuestions.filter((sec: any) => sec?.name == "Controls")[0]?.totalcount > 0) ||
          (this.isResubmit && this.showControlSection &&
            (this.totalEachTypeQuestions.filter((sec: any) => sec?.name == "Controls")[0]?.rejected > 0))
        ) {
          questionnaireType = 'Controls';
        }
      } else if (this.questionnaireType == 'Inherent Risk') {
        if (
          (!this.isResubmit && this.totalEachTypeQuestions.filter((sec: any) => sec?.name == "Controls")[0]?.totalcount > 0) ||
          (this.isResubmit && this.showControlSection &&
            (this.totalEachTypeQuestions.filter((sec: any) => sec?.name == "Controls")[0]?.rejected > 0))
        ) {
          questionnaireType = 'Controls';
        }
      } else if (this.questionnaireType == 'Controls') {
        questionnaireType = 'General';
      }
      if (this.isView) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: questionnaireType, action: 'view' } });
      }
      else if (this.isResubmit) {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: questionnaireType, action: 'resubmit' } });
      }
      else {
        this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: questionnaireType } });
      }
    }
    // },500); 
  }

  // initialSelectedStage(): any {
  //   this.selectedCategoryDetails = this.statusOfStageCompletion?.find((eachStage: any) => eachStage.isCompleted === false);
  //   this.selectedCategory = this.selectedCategoryDetails?.category;
  //   if (this.reVisitUnAnswered && this.allQstnAns) {
  //     let unanswered: any;

  //     if (this.isChecker) {
  //       if (this.isResubmit) {
  //         unanswered = this.allQstnAns.filter((x: any) => x.status == GlobalConstants.STATUSES.REJECTED.name);
  //       }
  //       else {
  //         unanswered = this.allQstnAns.filter((x: any) => x.status == GlobalConstants.STATUSES.MAKER_SUBMITTED.name);
  //       }
  //     }
  //     else {
  //       // if (this.isResubmit) {
  //       //   unanswered = this.allQstnAns.filter((x: any) => x.status == GlobalConstants.STATUSES.CHECKER_REJECTED.name);
  //       // }
  //       if (this.isResubmit) {
  //         const rejectedStatusValues = [
  //           GlobalConstants.STATUSES.CHECKER_REJECTED.value,
  //           GlobalConstants.STATUSES.INSPECTOR_REJECTED.value
  //         ];
  //         unanswered = this.allQstnAns.filter((x: any) => rejectedStatusValues.includes(x.statusValue));
  //       }
  //       else {
  //         unanswered = this.allQstnAns.filter((x: any) => !x.responseId || !x.userResponse);
  //       }
  //     }


  //     this.selectedCategoryDetails = this.statusOfStageCompletion.find((eachStage: any) => {
  //       let categoryUnanswered = unanswered.filter((y: any) => y.category == eachStage.category);
  //       if (categoryUnanswered?.length > 0) {
  //         this.unansweredQues = categoryUnanswered[0];
  //         //need to revisit below commented code: navigate to parent of unanswered
  //         if (this.unansweredQues?.hasParent) {
  //           this.unansweredQues = this.allQstnAns?.filter((ques: any) => ques?.quesguid == this.unansweredQues?.parentguid)[0];
  //         }
  //       }
  //       return categoryUnanswered && categoryUnanswered.length > 0 ? true : false;
  //     });
  //     this.selectedCategory = this.selectedCategoryDetails.category;
  //   }
  //   if (this.returnToAssessment && this.storageService.getSessionStorageData('selectedQuestionState')) {
  //     this.returnQuestion = this.storageService.getSessionStorageData('selectedQuestionState');
  //     if (this.returnQuestion && this.returnQuestion?.category) {
  //       this.selectedCategoryDetails = this.statusOfStageCompletion?.find((stage: any) => stage.category == this.returnQuestion?.category);
  //       this.selectedCategory = this.returnQuestion?.category;
  //     }
  //   }
  //   this.checkLastCategoryStatus();
  // }
  initialSelectedStage(): any {
    this.selectedCategoryDetails = this.statusOfStageCompletion?.find((eachStage: any) => eachStage.isCompleted === false);
    this.selectedCategory = this.selectedCategoryDetails?.category;

    if (this.reVisitUnAnswered && this.allQstnAns) {
      let unanswered: any;
      const rejectedStatusValues = [
        GlobalConstants.STATUSES.CHECKER_REJECTED.value,
        GlobalConstants.STATUSES.INSPECTOR_REJECTED.value
      ];
      if (this.isChecker) {
        if (this.isResubmit) {
          // const rejectedStatusValues = [GlobalConstants.STATUSES.REJECTED.value];
          unanswered = this.allQstnAns.filter((x: any) => rejectedStatusValues.includes(x.statusValue));
        } else {
          unanswered = this.allQstnAns.filter((x: any) => x.status == GlobalConstants.STATUSES.MAKER_SUBMITTED.name);
        }
      } else {
        if (this.isResubmit) {

          unanswered = this.allQstnAns.filter((x: any) => rejectedStatusValues.includes(x.statusValue));
        } else {
          unanswered = this.allQstnAns.filter((x: any) => !x.responseId || !x.userResponse);
        }
      }

      this.selectedCategoryDetails = this.statusOfStageCompletion.find((eachStage: any) => {
        const categoryUnanswered = unanswered.filter((y: any) => y.category === eachStage.category);
        if (categoryUnanswered?.length > 0) {
          this.unansweredQues = categoryUnanswered[0];
          if (this.unansweredQues?.hasParent) {
            this.unansweredQues = this.allQstnAns.find((ques: any) => ques?.quesguid === this.unansweredQues?.parentguid);
          }
        }
        return categoryUnanswered && categoryUnanswered.length > 0;
      });

      if (!this.selectedCategoryDetails) {
        // console.warn('No matching category found. Setting default category details to empty object.');
        this.selectedCategoryDetails = {};
        this.selectedCategory = ''; // or a fallback value
      } else {
        this.selectedCategory = this.selectedCategoryDetails.category;
      }
    }

    if (this.returnToAssessment && this.storageService.getSessionStorageData('selectedQuestionState')) {
      this.returnQuestion = this.storageService.getSessionStorageData('selectedQuestionState');
      if (this.returnQuestion && this.returnQuestion?.category) {
        this.selectedCategoryDetails = this.statusOfStageCompletion?.find((stage: any) => stage.category == this.returnQuestion?.category);
        this.selectedCategory = this.returnQuestion?.category;
      }
    }

    this.checkLastCategoryStatus();
  }
  handleResetReturnQues() {
    this.returnQuestion = null;
  }

  checkLastCategoryStatus() {
    this.isSelectedCategoryLast = false;
    if (this.statusOfStageCompletion.indexOf(this.selectedCategoryDetails) == this.statusOfStageCompletion?.length - 1) {
      this.isSelectedCategoryLast = true;
    }
  }

  generateCountOfQues() {
    let rqstBody = {
      questionnaire: this.assessmentDetails?.questionnaireguid,
      assessmentUnit: this.assessmentDetails?.assessmentunitguid,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };
    this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log('finally number of questions in tabs: ', resp);
      this.totalEachTypeQuestions = resp.totalEachTypeQuestions;
      this.progressCountState = resp;
    });
  }

  ngDestroy() {
    if (this.subscriptionEvent) {
      this.subscriptionEvent.unsubscribe();
    }
  }


}
